import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button as MuiButton, Typography } from "@mui/material";
import { spacing } from "@mui/system";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(6)};
  text-align: center;
  background: transparent;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function OperationFailed() {
  return (
    <Wrapper>
      <Helmet title="Operazione fallita" />
      <Typography component="h1" variant="h4" align="center" gutterBottom>
        Operazione fallita
      </Typography>
      <Typography component="p" variant="body1" align="center" gutterBottom>
        Qualcosa e&apos; andato storto. Riprova o contatta l&apos;assistenza.
      </Typography>

      <Button
        component={Link}
        to="/"
        variant="contained"
        color="secondary"
        mt={2}
      >
        Torna alla home
      </Button>
    </Wrapper>
  );
}

export default OperationFailed;
